import router from '@/router';

export default {
  login(session) {
    localStorage.setItem('session', JSON.stringify(session));
    router.push('/');
  },

  isLogged() {
    if (JSON.parse(localStorage.getItem('session'))) {
      return true;
    }
    return false;
  },

  getSessionToken() {
    if (this.isLogged()) {
      return JSON.parse(localStorage.getItem('session')).token;
    }
    return null;
  },

  getSessionRefreshToken() {
    if (this.isLogged()) {
      return JSON.parse(localStorage.getItem('session')).refreshToken;
    }
    return null;
  },

  getSessionUserLogin() {
    if (this.isLogged()) {
      // return process.env.EDOC_USER;
      return JSON.parse(localStorage.getItem('session')).userLogin;
    }
    return null;
  },

  getSession() {
    if (this.isLogged()) {
      return JSON.parse(localStorage.getItem('session'));
    }
    return null;
  },

  logout() {
    localStorage.removeItem('session');
    router.push('/login');
  },

};



// WEBPACK FOOTER //
// ./src/utils/auth.js